module.exports = __webpack_public_path__ + "img/dan-nelson-ah-HeguOe9k-unsplash (1).b436d8b9.jpg";